import { Typography } from "@mui/material";
import React from "react";
import DefaultPaper from "../../components/DefaultPaper";

import AddEditDialogTable from "../../components/Table/AddEditDialogTable";
import {
  confirmationLetterDataMapper,
  getConfirmationLetterListHeadForConfirmer,
} from "../../utils/ConfirmationLetterListHead";

const Dashboard = ({ title }) => {
  return (
    <>
      <Typography variant="h6">{title}</Typography>
      <DefaultPaper title={"回答依頼中確認状一覧"}>
        <AddEditDialogTable
          getPath={`/api/confirmer/GetConfirmationList`}
          headCells={getConfirmationLetterListHeadForConfirmer()}
          rowMapper={confirmationLetterDataMapper}
          listName={"確認状"}
          disablePagination
          disableAdd
          disableDelete
          disableEdit
        />
      </DefaultPaper>
    </>
  );
};
export default Dashboard;
